import { Injectable } from '@angular/core';
import { AnimationEvent } from '@angular/animations';

@Injectable()
export class ToolbarStateService {
    toolbarCollapsed: boolean = false;
    toolbarAnimating: boolean = false;
    scrollTop: number = 0;
    toolbarWidth: number;
    toolbarAnimationDisabled: boolean = false;

    /**
     * Handles scroll position updates and determines whether the toolbar
     * should collapse or expand based on scroll movement.
     *
     * @param scrollTop - The current scroll position of the container.
     */
    onScroll(scrollTop: number) {
        if (this.toolbarAnimating) {
            return;
        }
        const diff = this.scrollTop - scrollTop;

        if (diff > 80) {
            this.toolbarCollapsed = false;
        } else if (diff < -80) {
            this.toolbarCollapsed = true;
        } else {
            return;
        }
        this.scrollTop = scrollTop;
    }

    /**
     * Called when the toolbar animation starts.
     * Updates the animation state and adjusts the toolbar's display or width based on the animation target state.
     *
     * @param event
     */
    onAnimationStart(event: AnimationEvent) {
        this.toolbarAnimating = true;
        if (!event.toState) {
        event.element.style.display = 'flex';
        } else {
        this.toolbarWidth = event.element.clientWidth;
        }
    }

    /**
     * Called when the toolbar animation ends.
     * Resets the animation state and hides the toolbar element if the animation has collapsed it.
     *
     * @param event
     */
    onAnimationDone(event: AnimationEvent) {
        this.toolbarAnimating = false;
        if (event.toState) {
        event.element.style.display = 'none';
        }
    }

    /**
     * Sets the toolbar animation disabled state.
     */
    setToolbarAnimationDisabled(disabled: boolean): void {
        this.toolbarAnimationDisabled = disabled;
    }

    /**
     * Returns the current toolbar animation disabled state.
     *
     * @returns A boolean indicating whether toolbar animations are disabled.
     */
    getToolbarAnimationDisabled(): boolean {
        return this.toolbarAnimationDisabled;
    }
}
